var Messages = {
  //remove all mentions of testing time and prepaid plans --->
  salesAndSupportPage: {
    invalidEmail: 'please share a valid email',
    invalidMessage: 'please write a message',
    invalidName: 'please share your name',
    invalidOrganization: 'please share your organization',
    invalidMeetup: 'please share your meetup city',
    invalidAttendees: 'please share your expected attendees',
    invalidCountry: 'please select your country',
    invalidRole: 'please select your role',
    invalidNeedHelp: 'please select your option',
    invalidSponsorship: 'please select your sponsorship requirements',
    noemail: 'Please share your email address',
    noQueryType: 'please tell us what your query is about',
    noProjectURL: 'please share your project URL',
    noCompanyName: 'please share your company name',
    noRecaptcha: 'please validate the captcha',
    noPartnershipType: 'please select partnership type',
    invalidUserToken: 'user token not working',
    noContactNo: 'please share your contact number',
    invalidTitle: 'please write a title',
    validateText: 'Validating...',
    invalidWorkEmail: 'please share your work email',
    invalidUseCase: 'choose a product below to continue',
    invalidJobTitle: 'please select your current job title',
    invalidCountryDetails: 'please enter valid country details',
    invalidPhoneNumber: 'please enter a valid phone number',
    longRequest: 'Request is taking too long. Please try again later',
    somethingWrong: 'Something went wrong. Please try again later',
    notBusinessEmail: 'Please share valid business email'
  },
  emailValidationErrors: {
    invalidEmail: 'Invalid Email',
    invalidCharacters: 'Invalid Characters',
    modalInvalidEmail: 'Please enter a valid email address - ',
    modalInvalidCharacters: 'Email contains invalid non-english characters - ',
    businessEmailError: 'Enter work email'
  },
  signUpErrors: {
    invalidPassword: 'Invalid Password',
    termsAndConditions:
      'Please check the box to confirm acceptance of our <a target="_blank" href="/privacy">Privacy Policy</a> and <a target="_blank" href="/terms">Terms of Service</a>',
    passwordLength: 'At least 6 characters',
    fullNameLength: 'At least 3 characters',
    emptyOrganisationField: 'Enter company name'
  },
  cloudflareErrorStatusCode: {
    429: "Too many requests received from your network, please try again in some time or <a href='https://www.browserstack.com/contact?too_many_requests=true'>contact us</a>"
  },
  phoneNoValidationErrors: {
    noPhoneNo: 'please share your phone number',
    invalidPhoneNo: 'please share a valid phone number'
  }
};
